import { action, Action, thunk, Thunk } from 'easy-peasy';
import { Theme } from '@meitu/saas-ui';
import { IBatchTemplateData } from '@meitu/saas-editor-core/es/version-types';
import { IEditorType } from '@/types';

const { AppTheme, Helper } = Theme;

export interface IEditorModel {
    /** 当前编辑器类型 */
    editorType?: IEditorType;
    setEditorType: Action<IEditorModel, IEditorType>;

    /** 是否是背景操作 */
    isBackgroundOperation: boolean;
    setIsBackgroundOperation: Action<IEditorModel, boolean>;
    getIsBackgroundOperation: Thunk<IEditorModel>;

    /** 当前使用的功能 */
    feature: string;
    setFeature: Action<IEditorModel, string>;
    getFeature: Thunk<IEditorModel>;

    batchTemplateData: IBatchTemplateData | null;
    setBatchTemplateData: Action<IEditorModel, IBatchTemplateData | null>;

    /** 是否显示右侧面板 */
    isShowPanel: boolean;
    /** 设置是否显示右侧面板 */
    setIsShowPanel: Action<IEditorModel, boolean>;

    /** 是否显示左侧面板 */
    isShowCollapse: boolean;
    /** 设置是否显示左侧面板 */
    setIsShowCollapse: Action<IEditorModel, boolean>;
    getIsShowCollapse: Thunk<IEditorModel>;

    /** 全屏 */
    isFullscreen: boolean;
    /** 设置是否全屏 */
    setIsFullscreen: Action<IEditorModel, boolean>;

    /** 主题 */
    theme: string;
    setWhiteTheme: Action<IEditorModel>;
    setDarkTheme: Action<IEditorModel>;
    setXDesignTheme: Action<IEditorModel>;

    /** 禁用应用 */
    isDisable: boolean;
    /** 设置是否禁用应用 */
    setIsDisable: Action<IEditorModel, boolean>;

    /** 是否锁定面板 */
    isLock: boolean;
    /** 设置是否锁定面板 */
    setIsLock: Action<IEditorModel, boolean>;

    /** 禁用应用且显示面板 */
    isDisableAppAndShowPanel: boolean;
    /** 设置是否禁用应用且显示面板 */
    setIsDisableAppAndShowPanel: Action<IEditorModel, boolean>;

    /** 是否显示拼写错误 */
    isShowTypo: boolean;
    /** 设置是否显示拼写错误 */
    setIsShowTypo: Action<IEditorModel, boolean>;
}

export const editorModel: IEditorModel = {
    editorType: undefined,
    setEditorType: action((state, payload) => {
        state.editorType = payload;
    }),

    isBackgroundOperation: false,
    setIsBackgroundOperation: action((state, payload) => {
        state.isBackgroundOperation = payload;
    }),
    getIsBackgroundOperation: thunk((actions, payload, state) => {
        return state.getState().isBackgroundOperation;
    }),

    isFullscreen: false,
    setIsFullscreen: action((state, payload) => {
        state.isFullscreen = payload;
    }),

    feature: '',
    setFeature: action((state, payload) => {
        state.feature = payload;
    }),
    getFeature: thunk((action, payload, helper) => {
        return helper.getState().feature;
    }),

    isShowPanel: true,
    setIsShowPanel: action((state, payload) => {
        state.isShowPanel = payload;
    }),

    isShowCollapse: true,
    setIsShowCollapse: action((state, payload) => {
        state.isShowCollapse = payload;
    }),
    getIsShowCollapse: thunk((action, payload, helper) => {
        return helper.getState().isShowCollapse;
    }),

    batchTemplateData: null,
    setBatchTemplateData: action((state, batchTemplateData) => {
        state.batchTemplateData = batchTemplateData;
    }),

    theme: Helper.getTheme(),

    setWhiteTheme: action((state) => {
        state.theme = AppTheme.white;
        Helper.setTheme(AppTheme.white);
    }),

    setDarkTheme: action((state) => {
        state.theme = AppTheme.dark;
        Helper.setTheme(AppTheme.dark);
    }),

    setXDesignTheme: action((state) => {
        state.theme = AppTheme.xdesign;
        Helper.setTheme(AppTheme.xdesign);
    }),

    isDisable: false,
    setIsDisable: action((state, payload) => {
        state.isDisable = payload;
    }),

    isLock: false,
    setIsLock: action((state, payload) => {
        state.isLock = payload;
    }),

    isDisableAppAndShowPanel: false,
    setIsDisableAppAndShowPanel: action((state, payload) => {
        state.isDisableAppAndShowPanel = payload;
    }),

    isShowTypo: true,
    setIsShowTypo: action((state, payload) => {
        state.isShowTypo = payload;
    }),
};
